import {Component, Inject, OnInit} from '@angular/core';
import { aiTrasacion }  from '../_models/ar.models'
import { aiDoctor }  from '../_models/ar.models'


const enumARSystemIntegrationID_QuickBooks: string  = '00000539-1000-0000-0000-000000000002';

@Component({
  selector: 'app-accounting-integration',
  templateUrl: './accounting-integration.component.html',
  styleUrls: ['./accounting-integration.component.scss']
})   
export class AccountingIntegrationComponent {

  public selctedDoctorID : string ="0";
  public activeDoctor;

  public listOfDoctors : Array<aiDoctor>;

  public listOfTransactions :  Array<aiTrasacion>;

  public displayedColumns: string[] = ['PatientNo', 'AIRef', 'AICustomer', 'LastTran', 'NTC', 'RecType', 'PrevBalance', 'TDObalance', 'AIBalance' ];
 
  public countBalanceNotMatching: number = 0;
  public countPatientNotFound: number = 0;
  public countPatientNewTrans: number = 0;

  
  public logText : string;

 


  ngOnInit(): void {


    this.listOfDoctors = [
      {DoctorID : "001", FullName : "Dr. Garry Carr", enumARSystemIntegrationID: '00000539-1000-0000-0000-000000000002', iconpath : "assets/icons/valid-values/Color/Business/QuickBooksLogo.svg"},
      {DoctorID : "002", FullName : "Dr. Marry Smith", enumARSystemIntegrationID: '00000539-1000-0000-0000-000000000002', iconpath : "assets/icons/valid-values/Color/Business/QuickBooksLogo.svg"},
      {DoctorID : "003", FullName : "Dr. John Brown", enumARSystemIntegrationID: '00000539-1000-0000-0000-000000000002', iconpath : "assets/icons/valid-values/Color/Business/QuickBooksLogo.svg"}

    ];
    this.activeDoctor = this.listOfDoctors[0];

    this.listOfTransactions  = [
        { LedgerID : "11232", PatientNo: "1232", AIRef: "-", AICustomer: "-", LastTran:"", NTC: "2", RecType:"t", PrevBalance: "$0.00", TDObalance:"$0.00", AIBalance:"$0.00" , trStatus : 0},
        { LedgerID : "21443", PatientNo: "1532", AIRef: "-", AICustomer: "-", LastTran:"", NTC: "2", RecType:"t", PrevBalance: "$0.00", TDObalance:"$0.00", AIBalance:"$0.00" , trStatus : 1},
        { LedgerID : "13325", PatientNo: "1632", AIRef: "-", AICustomer: "-", LastTran:"", NTC: "2", RecType:"t", PrevBalance: "$0.00", TDObalance:"$0.00", AIBalance:"$0.00" , trStatus : 2},
        { LedgerID : "43325", PatientNo: "4632", AIRef: "-", AICustomer: "-", LastTran:"", NTC: "2", RecType:"t", PrevBalance: "$0.00", TDObalance:"$0.00", AIBalance:"$0.00" , trStatus : 3}
    ];


    this.logText = "";

    for (let i = 0; i < 90; i++) {
      this.logText += "Sync logs records: dataARIntegrationSyncLog ." + i +"<br/>" ;
    }

    document.getElementById('logTextDiv').innerHTML= this.logText;

    

  }

  getHighlightColor(row)  {
    var r : any;

    // coloring of the rows according to the status column 
  
    switch(row.trStatus) {
      case 0: {
        r='';
        break;
      }
      case 1: {
        r='ai-tr-bal-no-match';  // see CSS for defintion
        break;
      }
      case 2: {
        r='ai-tr-patient-not-found';  // see CSS for defintion
        break;
      }
      case 3: {
        r='ai-tr-patient-new-trans';  // see CSS for defintion
        break;
      }
      defult: {
        r='';
      }

    }
    return r;

  }




  btnClickDoctor(doc : aiDoctor)  {
    console.log(doc);
  }


}


